import React from 'react'
import NavBar from '../Layouts/Navbar'

const Header = () => {
  return (
    <header className='bg-tmdbDarkBlue'>
      <NavBar />
    </header>
  )
}

export default Header
